import React from "react";
import moment from "moment";
import Select from "react-select";

import NumberFormat from "react-number-format";
import { Button } from "react-bootstrap";
import { Scrollbars } from "react-custom-scrollbars";

import TableLoader, { TableColumn, TableRow } from "components/Table/Table.js";

import styles from "./style.module.css";

export default class RunRow extends React.PureComponent {
  render() {
    const { blueprint, onClick, isHighlight, onHover, history } = this.props;

    return (
      <TableRow
        isHighlight={isHighlight}
        onMouseEnter={onHover ? () => onHover(blueprint.id) : () => {}}
        onMouseLeave={onHover ? () => onHover(undefined) : () => {}}
      >
        <TableColumn>
          <a onClick={() => onClick()}>{blueprint.name}</a>
        </TableColumn>
        <TableColumn title={moment.utc(blueprint.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}>
          {moment.utc(blueprint.created_date).local().fromNow()}
        </TableColumn>
      </TableRow>
    );
  }
}
